import { Injectable } from '@angular/core';
import { CusHttp } from '../../../core/services/CusHttp';
import { URLSearchParams } from '@angular/http';
//获取简历详情
const RESUME_DETAIL = "v1/resume/detail?id=";
//人才库-加入人才库
const ADD_TALENT_POOL = "v1/talent-pool/add";
//企业批阅简历
const MARKING_RESUME = "v1/company/upd-status";
//检查人才是否被收藏
const IS_COLLECT = "v1/talent-pool/check?";
//获取公司岗位列表
const COM_POST = "v1/position/listby?";

//判断企业是否给学生发送过面试邀请
const ISSEND = "v1/interview-invitation/isinter?id=";
//企业发送面试邀请
const SEND_INVITE = "v1/interview-invitation/send-invitation";
@Injectable()
export class ResumeDetailService {

  constructor(
    private _http: CusHttp,

  ) { }

  //获取简历详情
  getResumeDetail( id: any ) {
    return this._http.get( `${RESUME_DETAIL}${id}` );
  }

  //加入人才库
  addTalentPool( position_id: any, resume_id: any ) {
    let a = new FormData;
    a.append( 'position_id', position_id );
    a.append( 'resume_id', resume_id );
    return this._http.post( `${ADD_TALENT_POOL}`, a );
  }

  //企业批阅简历
  ismarkResume( ids: any, delivery_status: any ) {
    let a = new FormData;
    a.append( 'ids', ids );
    a.append( 'delivery_status', delivery_status );
    return this._http.post( `${MARKING_RESUME}`, a );
  }

  //检查人才是否被收藏  公司id   简历id
  isCollect( company_id: any, resume_id: any ) {
    let a = new URLSearchParams;
    a.append( 'company_id', company_id );
    a.append( 'resume_id', resume_id );
    return this._http.get( `${IS_COLLECT}` + a.toString() );
  }

  //获取公司岗位列表  企业id
  getComPost( id: any ) {
    let a = new URLSearchParams;
    a.append( 'id', id );
    return this._http.get( `${COM_POST}` + a.toString() );
  }

  //判断企业是否给学生发送过面试邀请
  isSend( id: any ) {
    return this._http.get( `${ISSEND}${id}` );

  }

  //企业发送面试邀请
  sendInvite( stu_id, post_id, invite_time ) {
    let a = new FormData();
    a.append( 'stu_id', stu_id );
    a.append( 'post_id', post_id );
    a.append( 'invite_time', invite_time );
    return this._http.post( `${SEND_INVITE}`, a );
  }

}



// WEBPACK FOOTER //
// /data/wwwroot/xzhipin/app-client/src/app/user/company/resume-detail/resume-detail.service.ts